// apps/nos/client/src/services/cost_api.ts
import { serverURL } from "@/utils/serverURL";

export type CostGlobalsResponse = {
  globalMedianPricePerGramUsd: number | null;
};

export async function fetchCostGlobals(
  flavorId: string,
  signal?: AbortSignal,
): Promise<CostGlobalsResponse> {
  const res = await fetch(
    serverURL`/me/flavor/${flavorId}/cost-globals`,
    { credentials: "include", signal },
  );
  if (!res.ok) {
    let detail = "";
    try { detail = await res.text(); } catch { /* ignore */ }
    throw new Error(
      `GET /me/flavor/${flavorId}/cost-globals failed: ${res.status} ${detail.slice(0, 200)}`,
    );
  }
  return (await res.json()) as CostGlobalsResponse;
}
